<!--
  A filterable version of ElEntitySelect
  See ElFilterableSelect
-->

<template>
  <el-entity-select
    :value="value"
    :type="type"
    :prefix="prefix"
    :info="info"
    :class-name="className"
    :style-obj="styleObj"
    v-bind="$attrs"
    v-on="$listeners"
    filterable
    :filter-method="filterMethod"
    @focus="handleFocus"
    @visible-change="handleOpen">
    <template slot="info" slot-scope="{item}">
      <slot name="info" :item="item"></slot>
    </template>
    <slot :query="query" :options="filteredOptions">
      <el-entity-option
        v-for="(item, index) in filteredOptions"
        :item="item"
        :type="type"
        :key="itemKey(item, index)"
        :value="itemValue(item)"
        :label="itemLabel(item)"
        :class-name="itemClass(item)"
        :style-obj="itemStyle(item)"
        :info="itemInfo(item)">
        <slot name="option" :item="item" :index="index">
          <span class="el-filterable-select__left">{{ item.left }}</span>
          <strong class="el-filterable-select__match">{{ item.match }}</strong>
          <span class="el-filterable-select__right">{{ item.right }}</span>
        </slot>
        <template slot="info">
          <slot name="info" :item="item" :index="index"></slot>
        </template>
      </el-entity-option>
    </slot>
  </el-entity-select>
</template>

<script>
import { getValueByPath } from 'element-ui/src/utils/util'

import ElEntitySelect from './ElEntitySelect.vue'
import ElEntityOption from './ElEntityOption.vue'
import { filterSuggestions, orderSuggestions } from '../../utils/filter.js'

export default {
  name: 'ElFilterableEntitySelect',

  components: {
    ElEntitySelect,
    ElEntityOption,
  },

  props: {
    value: {},
    options: Array,
    // the type of entity, changes its style
    type: String,
    // the prefix to show
    prefix: String,
    // the info to show next to the name
    info: String,
    // the class to use
    className: String,
    // the style to apply
    styleObj: Object,
    // a filter to apply when no filter is given
    preFilter: String,

    keyField: {
      type: [String, Function],
      default: null,
    },
    valueField: {
      type: [String, Function],
      default: 'value',
    },
    labelField: {
      type: [String, Function],
      default: null,
    },
    classField: {
      type: [String, Function],
      default: 'class',
    },
    styleField: {
      type: [String, Function],
      default: 'style',
    },
    infoField: {
      type: [String, Function],
      default: null,
    },
  },

  data () {
    return {
    // filteredOptions [],
      query: '',
      opened: false,
    }
  },

  computed: {
    filteredOptions () {
      // when not opened, keep in the options the current one, to display its label
      if (!this.opened) {
        return (this.options || []).filter(
          option => this.itemValue(option) === this.value)
      // else search in the options
      } else if (this.query) {
        return filterSuggestions(this.query, this.options || [], this.itemLabel.bind(this))
      } else {
        return orderSuggestions(this.preFilter, this.options || [], this.itemLabel.bind(this))
      }
    },
  },

  methods: {
    itemKey (item, index) {
      let keyField = this.keyField || this.valueField
      if (typeof keyField === 'function') return keyField(item, index)
      if (typeof item !== 'object') return item
      else if (keyField) return getValueByPath(item, keyField)
      else return index
    },
    itemValue (item) {
      if (typeof this.valueField === 'function') return this.valueField(item)
      if (!this.valueField || typeof item !== 'object') return item
      return getValueByPath(item, this.valueField)
    },
    itemLabel (item) {
      let labelField = this.labelField || this.valueField
      if (typeof labelField === 'function') return labelField(item)
      if (typeof item !== 'object') return item
      else if (labelField) return getValueByPath(item, labelField)
      else return ''
    },
    itemClass (item) {
      if (typeof this.classField === 'function') return this.classField(item)
      else if (this.classField && typeof item === 'object') return getValueByPath(item, this.classField)
      else return this.className || this.type && 'el-entity-autocomplete__item-' + this.type || ''
    },
    itemStyle (item) {
      if (typeof this.styleField === 'function') return this.styleField(item)
      else if (this.styleField && typeof item === 'object') return getValueByPath(item, this.styleField)
      return this.styleObj
    },
    itemInfo (item) {
      if (typeof this.infoField === 'function') return this.infoField(item)
      if (!this.infoField || typeof item !== 'object') return null
      return getValueByPath(item, this.infoField)
    },

    // filterMethod (query) {
    //   this.filteredOptions = filterSuggestions(query, this.options || [], this.computedLabel)
    // },
    filterMethod (query) { this.query = query },
    handleFocus () { this.query = '' },
    handleOpen (opened) { this.opened = opened },
  },
}
</script>
